import clsx from "clsx";

type Props = {
  text: string;
  color?: "green" | "lightBlue";
};

export default function BadgeSale({ text, color = "green" }: Props) {
  return (
    <div
      className={clsx(
        "absolute flex top-[2rem] -right-[3.5rem] items-center h-[2.375rem] w-[13rem] py-1 rotate-45",
        color === "green" ? "bg-gradient-green" : "bg-gradient-lightBlue",
      )}
    >
      <div
        className={clsx(
          "flex item-center justify-center w-full h-full text-14 font-bold text-white uppercase border-t-2 border-b-2 border-dashed",
          color === "green"
            ? "border-t-[#84FF97] border-b-[#84FF97]"
            : "border-t-[#84E4FF] border-b-[#84E4FF]",
        )}
      >
        <p className="pt-0.75">{text}</p>
      </div>
    </div>
  );
}
